import http from './http.js'
export const api = {
	/**
	 * 案例列表
	 * @param {*} obj
	 * @returns
	 */
	contentAl (obj) {
		return http.post('pc/content/al', obj)
	},
	// 根据服务查检验师
	listByServe (obj) {
		return http.post('pc/doc/list-by-serve', obj)
	},
	// 案例详情
	alDetail (obj) {
		return http.post('pc/content/al-detail', obj)
	},

	// 手机号前缀
	prefix (obj) {
		return http.post('app/user/prefix', obj)
	},
	// 获取验证码
	code (obj) {
		return http.post('pc/user/get-code', obj)
	},
	// 注册
	register (obj) {
		return http.post('pc/user/register', obj)
	},
	registerApp(obj){
		return http.post('app/user/register',obj)
	},
	// 登录
	login (obj) {
		return http.post('pc/user/login', obj)
	},
	// 忘记密码
	changePassword (obj) {
		return http.post('pc/user/change-password', obj)
	},
	// 获取个人信息
	info (obj) {
		return http.post('pc/user/info', obj)
	},
	// 修改个人信息
	update (obj) {
		return http.post('pc/user/update', obj)
	},
	// 协议
	agreement (obj) {
		return http.post('pc/content/agreement', obj)
	},
	// 首页轮播图
	slideshow (obj) {
		return http.post('pc/content/slide-show', obj)
	},
	// 客服信息
	serviceinfo (obj) {
		return http.post('pc/content/service-info', obj)
	},
	// 工作地区一级
	areafirst (obj) {
		return http.post('pc/content/area-first', obj)
	},
	// 工作地区二级
	areasecond (obj) {
		return http.post('pc/content/area-second', obj)
	},
	// 工作地区三级
	areathird (obj) {
		return http.post('pc/content/area-third', obj)
	},
	// 检验师列表
	list (obj) {
		return http.post('pc/doc/list', obj)
	},
	// 明星检验师
	liststar (obj) {
		return http.post('pc/doc/list-star', obj)
	},
	// 服务列表
	serve (obj) {
		return http.post('pc/doc/serve', obj)
	},
	serveList (obj) {
		return http.post('pc/content/serve-list', obj)

	},
	// 热门服务
	serveHot (obj) {
		return http.post('pc/doc/serve-hot', obj)
	},
	// 检验师详情
	detail (obj) {
		return http.post('pc/doc/detail', obj)
	},
	// 评价列表
	appriselist (obj) {
		return http.post('pc/doc/apprise-list', obj)
	},
	// 是否收藏
	iscategory (obj) {
		return http.post('pc/doc/is-category', obj)
	},
	// 收藏、取消收藏
	category (obj) {
		return http.post('pc/doc/category', obj)
	},
	// 收藏列表
	categorylist (obj) {
		return http.post('pc/doc/category-list', obj)
	},
	// 投诉建议
	opinion (obj) {
		return http.post('pc/content/opinion', obj)
	},
	// 常见问题列表
	question (obj) {
		return http.post('pc/content/question', obj)
	},
	// 用户下单
	create (obj) {
		return http.post('pc/order/create', obj)
	},
	// 支付
	createOrder (obj) {
		return http.post('payPal/createOrder', obj)
	},
	// 订单列表
	orderlist (obj) {
		return http.post('pc/order/list', obj)
	},
	// 订单详情
	orderdetail (obj) {
		return http.post('pc/order/detail', obj)
	},
	// 订单取消/退款/售后原因列表
	cancelreason (obj) {
		return http.post('pc/order/cancel-reason', obj)
	},
	// 取消/退款/售后订单
	cancel (obj) {
		return http.post('pc/order/cancel', obj)
	},
	// 取消是否需要扣费
	beforecancel (obj) {
		return http.post('pc/order/before-cancel', obj)
	},
	// 订单通知提醒记录
	noticelist (obj) {
		return http.post('pc/order/notice-list', obj)
	},
	// 发送通知提醒
	notice (obj) {
		return http.post('pc/order/notice', obj)
	},
	// 确定验收
	confirm (obj) {
		return http.post('pc/order/confirm', obj)
	},
	// 去评价
	appraise (obj) {
		return http.post('pc/order/appraise', obj)
	},
	// 查看证书图片
	certificate (obj) {
		return http.post('pc/order/certificate', obj)
	},
	// 查看工作进度-监装
	schedulejz (obj) {
		return http.post('pc/order/schedule-jz', obj)
	},
	// 查看工作进度-量油
	schedulely (obj) {
		return http.post('pc/order/schedule-ly', obj)
	},
	// 查看工作进度-加油
	schedulejy (obj) {
		return http.post('pc/order/schedule-jy', obj)
	},
	// 查看工作进度-水尺
	schedulesc (obj) {
		return http.post('pc/order/schedule-sc', obj)
	},
	// 查看工作进度-保险
	schedulebx (obj) {
		return http.post('pc/order/schedule-bx', obj)
	},
	//监装日报列表
	Dailyreport (obj) {
		return http.post('app/order/jz1-list', obj)
	},
	//监装看货报列表
	khblist (obj) {
		return http.post('app/order/jz0-list', obj)
	},
	//监装开航报回显
	khb (obj) {
		return http.post('pc/order/schedule-jz2', obj)
	},
	zb (obj) {
		return http.post('pc/order/schedule-jz3', obj)
	},

	rb (obj) {
		return http.post('pc/order/schedule-jz1', obj)
	},
	jz0 (obj) {
		return http.post('pc/order/schedule-jz0', obj)
	},
	isChina (s) {
		var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
		if (reg.test(s)) {
			alert("包含汉字！");
		} else {
			alert("没有包含汉字！");
		}
	},
	desensitizedName () {

	},
	// 获取邮箱验证码
	getCodeMail (obj) {
		return http.post('pc/user/get-code-mail', obj)
	},
	listJy (obj) {
		return http.post('pc/doc/list-jy', obj)
	},


}
